import axios from 'axios'
import Vue from 'vue'
import VueToastr from '@deveodk/vue-toastr'

const { API_URL } = process.env;

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'error',
  defaulttitle: 'Atenção',
  defaultTimeout: 10000
})

const consVue = new Vue();

export const client = axios.create({
  baseURL: API_URL
});

client.interceptors.request.use(function (config) {
  config.headers['Authorization'] = 'Bearer ' + localStorage.token;
  config.headers['Access-Control-Allow-Origin'] = '*';

  return config;
});

client.interceptors.response.use(function (response) {

  if(response.data.msg) {
    if(response.data.msg != '') {
      consVue.$toastr('success', response.data.msg)
    }
  }

  return response;

}, function (error) {

  if (error.response) {

    if (error.response.data.msg) {

      consVue.$toastr('error', error.response.data.msg, 'Atenção!')
      return Promise.reject(error)

    } else if(error.response.data.errors) {

      $.each(error.response.data.errors, function( key, value ) {
        consVue.$toastr('error', value[0], 'Erro')
      });

      return Promise.reject(error)

    } else {
    if(error.response.status != 401) {
        consVue.$toastr('error', 'Erro ' + error.response.status + ' atualize e tente novamente.', 'Atenção!')
        return Promise.reject(error)
      } else {
        consVue.$toastr('error', error.response.data.message, 'Atenção!')
        window.location = '/sicoobauto/#/login'
    }
  }
  } else if (error.request) {

    consVue.$toastr('error', error.request, 'Atenção!')
    return Promise.reject(error)

  } else {
    consVue.$toastr('error', 'Error', error.message, 'Atenção!')
    return Promise.reject(error)

  }
})



// WEBPACK FOOTER //
// ./src/api/backend.js